import React from "react";
import useScrollAnimation from "../hooks/useScrollAnimation";
import "./SunNeverStops.css";

export default function SunNeverStops() {
  const sectionRef = useScrollAnimation(({ gsap, el }) => {
    gsap.to(el.querySelector(".sun-stops__image"), {
      rotate: 20,
      scale: 1.2,
      ease: "none",
      scrollTrigger: {
        trigger: el,
        start: "top bottom",
        end: "bottom top",
        scrub: 0.8,
      },
    });
    gsap.to(el.querySelector(".sun-stops__ray"), {
      xPercent: 140,
      ease: "none",
      scrollTrigger: {
        trigger: el,
        start: "top bottom",
        end: "bottom top",
        scrub: 0.8,
      },
    });
    gsap.fromTo(
      el.querySelector(".sun-stops__title"),
      { xPercent: -6 },
      {
        xPercent: 6,
        ease: "none",
        scrollTrigger: {
          trigger: el,
          start: "top bottom",
          end: "bottom top",
          scrub: 0.8,
        },
      }
    );
  }, []);

  return (
    <section className="sun-stops" ref={sectionRef}>
      <div className="sun-stops__image" aria-hidden="true" />
      <div className="sun-stops__ray" aria-hidden="true" />
      <div className="sun-stops__scrim" />
      <div className="container sun-stops__content">
        <h2 className="sun-stops__title">
          THE SUN
          <br />
          <span className="glow-text">NEVER STOPS.</span>
        </h2>
        <p>Neither should progress.</p>
      </div>
    </section>
  );
}
